var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3Dots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.34497 7C0.605237 7 0 7.60524 0 8.34497C0 9.08471 0.605237 9.68994 1.34497 9.68994C2.08471 9.68994 2.68994 9.08471 2.68994 8.34497C2.68994 7.60524 2.08471 7 1.34497 7ZM14.7903 7C14.0506 7 13.4453 7.60524 13.4453 8.34497C13.4453 9.08471 14.0506 9.68994 14.7903 9.68994C15.53 9.68994 16.1353 9.08471 16.1353 8.34497C16.1353 7.60524 15.53 7 14.7903 7ZM8.07153 7C7.3318 7 6.72656 7.60524 6.72656 8.34497C6.72656 9.08471 7.3318 9.68994 8.07153 9.68994C8.81127 9.68994 9.41651 9.08471 9.41651 8.34497C9.41651 7.60524 8.81127 7 8.07153 7Z",
    fill: "#F7B84B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Dots);
export default __webpack_public_path__ + "static/media/3dots.bdcd76f1e3033523483186a4fcc70c17.svg";
export { ForwardRef as ReactComponent };